package br.com.texeratx.boardgametimeapp.core.spotify.auth

internal actual object SpotifyCrypto {
    actual fun sha256(input: ByteArray): ByteArray {
        error("SpotifyCrypto.sha256 ainda não implementado no JS (web ficará para depois).")
    }

    actual fun base64UrlNoPadding(input: ByteArray): String {
        error("SpotifyCrypto.base64UrlNoPadding ainda não implementado no JS (web ficará para depois).")
    }
}
